export default __webpack_public_path__ + "static/media/calendarPay.e6bceb32.svg";